import { writable } from "svelte/store";
function createMyStore() {
  const { subscribe, set, update } = writable({
    variables: [],
    scenarios: [],
    scenarioVars: [],
    saveStatus: "",
    safeToNavigate: true,
  });

  return {
    subscribe,
    update,
    set,
    clear: () => {
      set(
        (n) =>
          new {
            variables: [],
            scenarios: [],
            scenarioVars: [],
            saveStatus: "",
            safeToNavigate: true,
          }()
      );
    },
    setSaveStatus: (saveStatus) => {
      update((n) => Object.assign(n, { saveStatus: saveStatus }));
      if (
        saveStatus != "" &&
        saveStatus != "savedlocal" &&
        saveStatus != "saved"
      ) {
        update((n) => Object.assign(n, { safeToNavigate: false }));
      } else {
        update((n) => Object.assign(n, { safeToNavigate: true }));
      }
    },
  };
}
export const inputVariableStore = createMyStore();
